﻿<script setup lang="ts">

    import BoolElement from '@/shared/components/BoolElement.vue';
    import { usePipeClassStore } from '@/stores/pipeClassStore.ts';
    import { PipingClassGenericView } from '@/apps/STID_Pipe/pipingClass.ts';
    import { watch } from 'vue';

    const pipeClassStore = usePipeClassStore();
    const emit = defineEmits<{
        /*
        A new value was picked in the selector
         */
        select: [payload: PipingClassGenericView | null];
        /*
        The selected value in the underlying store was modified
         */
        modified: [payload: PipingClassGenericView | null];
    }>();
    function onPipeClassSelect(newValue: PipingClassGenericView) {
        pipeClassStore.setPipingClass(newValue.Id);
        emit('select', newValue);
    }
    watch(() => pipeClassStore.selectedPipingClass, (newValue: PipingClassGenericView | null) => {
        emit('modified', newValue);
    });
</script>

<template>
    <b-table
        :selected="pipeClassStore.selectedPipingClass"
        height="60vh"
        sticky-header
        hoverable
        striped
        bordered
        :data="pipeClassStore.pipingClasses"
        :loading="pipeClassStore.loading.pipingClasses"
        :mobile-cards="false"
        @select="onPipeClassSelect">
        <b-table-column
            field="Name"
            label="Piping class"
            width="120px"
            sortable
            searchable>
            <template #default="{ row }">
                {{ row.Name }}
            </template>
        </b-table-column>
        <b-table-column
            v-slot="slotProps"
            sortable
            field="IsValid"
            centered
            label="Valid">
            <bool-element :value="slotProps.row.IsValid" />
        </b-table-column>
        <template #empty>
            <div class="has-text-centered">
                No piping classes
            </div>
        </template>
    </b-table>
</template>

<style scoped>

</style>
